
import './App.css';
import Movies  from './components/movies';

function App() {
  return (
    <main className='container'>
      <Movies />
    </main>
  );
}

export default App;
